import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
type PositionBadgeProps = {
  position: number;
};
export default function PositionBadge(t0) {
  const $ = _c(8);
  const {
    position
  } = t0;
  const t1 = (position === 1 || position === 2 || position === 3) && "mx-auto flex size-6 items-center justify-center rounded-full border-2 p-1";
  const t2 = position === 1 && "border-[#facd01] bg-[#feea67] text-[#f89a00]";
  const t3 = position === 2 && "border-[#aac0d3] bg-[#d6e4ef] text-[#92a5b6]";
  const t4 = position === 3 && "border-[#d6975e] bg-[#f7bd8b] text-[#cb7703]";
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = cn("text-center font-semibold", t1, t2, t3, t4);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== position || $[6] !== t5) {
    t6 = <div className={t5}>{position}</div>;
    $[5] = position;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}